/* istanbul ignore file */
import { sendGAEvent } from '@noths/polaris-client-google-analytics';
import { EventsMap } from '@noths/polaris-client-next-redux';
import { PayloadAction } from '@reduxjs/toolkit';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectSortingOption } from '../modules/selectors';
import { actions } from '../modules/slice';

export const GAEventsMap: EventsMap<ReduxApplicationState> = {
  [actions.selectSortOption.type]: (state, nextState, action) => {
    const { payload: sortOptionId } = action as PayloadAction<string>;
    const sortOption = selectSortingOption(state, sortOptionId);

    if (sortOption) {
      sendGAEvent({
        event: 'custom_event',
        event_category: 'Sort Results',
        event_action: 'sort by',
        event_label: sortOption.title,
      });
    }
  },
};
